import { render, staticRenderFns } from "./ezCmsVelaPlus.vue?vue&type=template&id=88bf675a&scoped=true"
import script from "./ezCmsVelaPlus.vue?vue&type=script&lang=js"
export * from "./ezCmsVelaPlus.vue?vue&type=script&lang=js"
import style0 from "./ezCmsVelaPlus.vue?vue&type=style&index=0&id=88bf675a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bf675a",
  null
  
)

export default component.exports